import { render, staticRenderFns } from "./OrticButton.vue?vue&type=template&id=1f3811da&"
import script from "./OrticButton.vue?vue&type=script&lang=js&"
export * from "./OrticButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports